import React, { useState } from "react";
import { Helmet } from 'react-helmet';  // Importera Helmet
import StadContactForm from '../components/StadContactForm';

const faqData = [
  {
    question: "Vad ingår i en fönsterputsning?",
    answer: "En vanlig fönsterputsning inkluderar tvätt av både insidan och utsidan av dina fönster, rengöring av fönsterkarmar och fönsterbrädor samt torkning av alla ytor. Om du har svåråtkomliga fönster eller specifika önskemål kan det vara bra att diskutera detta med oss i förväg."
  },
  {
    question: "Hur ofta bör jag boka fönsterputsning?",
    answer: "Vi rekommenderar att du bokar fönsterputsning 2–4 gånger om året, beroende på väderförhållanden och var ditt hem ligger. Om ditt hus ligger i ett område med mycket föroreningar, pollen eller om du har fönster som är extra utsatta, kan det vara en god idé att boka putsning oftare."
  },
  {
    question: "Behöver jag vara hemma när fönsterputsaren kommer?",
    answer: "Nej, du behöver inte vara hemma om vi har tillgång till ditt hem eller om fönstren kan nås från utsidan. Vi kan utföra arbetet när det passar dig bäst."
  },
  {
    question: "Vad kostar fönsterputsning?",
    answer: "Kostnaden för fönsterputsning beror på flera faktorer, som antalet fönster och svårighetsgraden på uppdraget. Vi erbjuder ett transparent och konkurrenskraftigt pris, och vi kan ge dig en offert baserat på dina behov."
  },
  {
    question: "Vad gör jag om vädret är dåligt på den bokade dagen?",
    answer: "Om vädret inte är bra för fönsterputsning, till exempel om det regnar eller blåser mycket, kommer vi att kontakta dig för att boka om tiden."
  },
  {
    question: "Erbjuder ni några rabatter för återkommande kunder?",
    answer: "Ja, vi värdesätter våra återkommande kunder och erbjuder rabatter för dem. Kontakta oss för att ta reda på mer om våra erbjudanden!"
  },
  {
    question: "Använder ni miljövänliga rengöringsmedel?",
    answer: "Ja, vi använder miljövänliga och skonsamma rengöringsmedel så långt det är möjligt. Vi prioriterar både ett bra resultat och att ta hand om både miljön och din inomhusluft."
  }
];

const FAQItem = ({ question, answer, isOpen, onClick }) => (
  <div className="border-b border-gray-300 py-4">
    <button
      className="w-full flex justify-between items-center text-left text-lg font-medium text-green-700"
      onClick={onClick}
    >
      <span>{question}</span>
      <span>{isOpen ? "-" : "+"}</span>
    </button>
    {isOpen && (
      <p className="mt-2 text-gray-700 text-base leading-relaxed">
        {answer}
      </p>
    )}
  </div>
);

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const handleClick = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="w-full py-16 bg-gray-50">
      <div className="max-w-4xl mx-auto px-6">
        <h2 className="text-3xl font-bold text-green-700 mb-8 text-center">
          Frågor & Svar
        </h2>
        {faqData.map((item, index) => (
          <FAQItem
            key={index}
            question={item.question}
            answer={item.answer}
            isOpen={openIndex === index}
            onClick={() => handleClick(index)}
          />
        ))}
      </div>
    </section>
  );
};

const Fonsterputs = () => {
  return (
    <>
      <Helmet>
        <title>Fönsterputs – Kristallklara Fönster med Provalt Service AB</title>
        <meta name="description" content="Vi erbjuder professionell fönsterputs in- och utvändigt för hem och företag. Låt oss ge dina fönster en skinande klar och fläckfri yta." />
        <link rel="canonical" href="https://provalt.se/fonsterputs" />
      </Helmet>
      <section className="w-full py-16 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          {/* Översta sektionen: grid med text + bild */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
            {/* Vänsterkolumn – text */}
            <div>
              <h1 className="text-3xl md:text-4xl font-bold text-green-700 mb-4">
                Professionell Fönsterputsning
              </h1>
              <h2 className="text-2xl font-bold text-green-600 mb-4">
                – Låt Ditt Hem Skinna Klart och Rent!
              </h2>
              <p className="text-gray-700 text-lg leading-relaxed">
                Vi erbjuder professionell fönsterputsning som ger dina fönster en kristallklar finish.
                <br /><br />
                Oavsett om du behöver en enkel putsning eller hjälp med svåråtkomliga fönster, ser vi till att ditt hem får ett fräscht och rent resultat – snabbt och effektivt!
                <br /><br />
                Kontakta oss idag för att boka fönsterputs – som privatperson eller företag!
              </p>
            </div>

            {/* Högerkolumn – bild */}
            <div>
              <img
                src="/images/cleaning/fonsterputs.webp"
                alt="Fönsterputsning"
                className="w-full h-auto rounded-2xl shadow-lg object-cover"
              />
            </div>
          </div>

          {/* Nedre sektion: rubrik + lista */}
          <div className="mt-16">
            <h2 className="text-2xl font-bold text-green-600 mb-4">
              – Varför välja Provalt Service AB?
            </h2>
            <ul className="list-disc list-inside text-gray-700 text-lg space-y-3">
              <li>
                <strong>Erfaren och noggrann personal</strong> – Vi har lång erfarenhet och vet hur vi får fönster att glänsa.
              </li>
              <li>
                <strong>Rätt utrustning och miljövänliga produkter</strong> – Vi använder skonsamma rengöringsmedel och proffsverktyg.
              </li>
              <li>
                <strong>Smidigt och enkelt</strong> – Vi anpassar oss efter dina behov och tider som passar dig.
              </li>
              <li>
                <strong>För både privatpersoner och företag</strong> – Oavsett om du behöver putsning av villafönster, butiksglas eller kontorsfönster, så fixar vi det!
              </li>
            </ul>
          </div>
        </div>
      </section>

      <section className="w-full py-16 bg-gray-100">
        <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-2 gap-12 items-start">
          {/* Vänster – Text */}
          <div>
            <h2 className="text-3xl font-bold text-green-700 mb-4">Kontakta oss – Vi hjälper dig gärna!</h2>
            <p className="text-gray-700 text-lg leading-relaxed mb-4">
              Har du frågor om våra tjänster eller vill boka en fönsterputsning? Tveka inte att höra av dig!
              Oavsett om det gäller privatpersoner, företag eller sommarstugor är vi här för att ge dig bästa servicen och de renaste fönstren.
            </p>
            <p className="text-gray-700 text-lg leading-relaxed mb-4">
              Fyll i kontaktformuläret nedan, så återkommer vi så snart som möjligt.
            </p><br/>
            <p className="text-gray-700 text-lg leading-relaxed">
              Vi erbjuder flexibla tider och anpassar vår service efter dina behov. Vi ser fram emot att ge ditt hem eller kontor skinande rena fönster!
            </p>
          </div>

          <StadContactForm />

        </div>
      </section>

      <section className="w-full py-16 bg-white">
        <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
            
            {/* Vänsterkolumn – Text */}
            <div>
            <h2 className="text-3xl font-bold text-green-700 mb-4">
                Att tänka på innan vi kommer
            </h2>
            <p className="text-gray-700 text-lg leading-relaxed mb-4">
                Vill du få dina fönster skinande rena så smidigt som möjligt? Här är tre enkla steg som hjälper oss att göra jobbet effektivt och ge dig bästa möjliga resultat!
            </p>

            <ol className="list-decimal list-inside space-y-4 text-gray-700 text-lg">
                <li>
                <strong>Förbered innan vi kommer:</strong><br />
                Plocka undan föremål nära fönstren, såsom blommor, ljusstakar eller dekorationer.<br />
                Se till att vi har fri väg till fönstren, både inomhus och utomhus.
                </li>
                <li>
                <strong>Underlätta vårt arbete:</strong><br />
                Om möjligt, se till att fönstren är stängda innan vi påbörjar putsningen.<br />
                Har du djur hemma? Det kan vara bra att hålla dem på avstånd under arbetet.<br />
                Vid behov, meddela oss om särskilda önskemål eller känsliga fönster i förväg.
                </li>
                <li>
                <strong>Efter putsningen:</strong><br />
                Inspektera gärna fönstren i dagsljus för att se det fantastiska resultatet!<br />
                Om du upptäcker något vi kan förbättra, tveka inte att höra av dig. Vi vill att du ska vara 100 % nöjd!<br />
                Passa på att njuta av dina skinande rena fönster – och boka gärna in nästa putsning direkt!
                </li>
            </ol>
            </div>

            {/* Högerkolumn – Bild */}
            <div>
            <img
                src="/images/cleaning/fonsterputs-1.webp" // <-- ersätt med korrekt sökväg till din bild
                alt="Förberedelser inför fönsterputs"
                className="w-full h-auto rounded-2xl shadow-lg object-cover"
            />
            </div>
        </div>
      </section>

      <FAQSection />
    </>
  );
};

export default Fonsterputs;
